import { ObjectLoadingCover } from "components/utils/object-loading-cover";
import { editorContextStore } from "contexts/editor-context";

export function ActiveObjectLoadingCover() {
  const activeObject = editorContextStore((state) => state.activeObject);
  return <ObjectLoadingCover object={activeObject} />;
}
